<template>
     <div class="merge-contacts-ctn">
        <div class="columns toolbar-box">
            <div class="column is-12-tablet is-12-desktop action-box">
                <o-field>
                    <o-input
                            v-model="filters.name"
                            placeholder="Contact name / company name"
                            icon="search"
                            type="search"
                            @update:modelValue="fetchPaginatedData(true)"
                    />
                </o-field>
                <div class="field is-grouped">
                    <p class="control">
                        <button class="button" @click="handleRefresh">
                            <span class="icon">
                                <i class="fa fa-refresh"></i>
                            </span>
                            <span>Refresh</span>
                        </button>
                    </p>
                    <p v-if="checkedRows.length > 0" class="control">
                        <a @click.prevent="handleMergeSelected(checkedRows)" class="button is-success">
                            <span class="icon"><i class="fa fa-compress"></i></span>
                            <span>Merge ({{ checkedRows.length }}) contacts</span>
                        </a>
                    </p>
                    <p v-if="checkedRows.length > 0" class="control">
                        <a @click.prevent="clearSelectedRows" class="button is-default">
                            <span class="icon"><i class="fa fa-eraser"></i></span>
                            <span>Clear selection</span>
                        </a>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <o-table
                    v-if="isTableVisible"
                    :checkable="table.checkable"
                    :checked-rows="checkedRows"
                    @update:checkedRows="$event => checkedRows = $event"
                    :current-page="currentPage"
                    :data="paginatedData"
                    :detail-transition="transitionName"
                    :detailed="table.detailed"
                    :is-row-checkable="row => true"
                    :loading="loading"
                    :opened-detailed="defaultOpenedDetails"
                    :paginated="true"
                    :pagination-simple="true"
                    :per-page="table.perPage"
                    :show-detail-icon="showDetailIcon"
                    :total="total"
                    @page-change="onPageChange"
                    @sort="onSort"
                    aria-next-label="Next page"
                    aria-previous-label="Previous page"
                    aria-page-label="Page"
                    aria-current-label="Current page"
                    backend-pagination
                    backend-sorting
                    class="merge-contacts-table fullwidth-table"
                    custom-detail-row
                    ref="table"
                    >
                    <template>
                        <o-table-column #default="{row}" field="Qty" label="Qty">
                            <div class="o-input-width-auto">
                                <span>{{ row['count'] }}</span>
                            </div>
                        </o-table-column>
                        <template v-for="col in tableColumns">
                            <o-table-column #default="{row}" v-if="col.field === 'first_name'" :field="col.field" :label="col.label" :key="col.field">
                                <o-input class="o-input-width-auto" v-model="row[col.field]" />
                            </o-table-column>
                            <o-table-column #default="{row}" v-else-if="col.field === 'last_name'" :field="col.field" :label="col.label" :key="col.field">
                                <o-input class="o-input-width-auto" v-model="row[col.field]" />
                            </o-table-column>
                            <o-table-column #default="{row}" v-else-if="col.field === 'email'" :field="col.field" :label="col.label" :key="col.field">
                                <o-input class="o-input-width-auto" type="email"  placeholder="company@example.com" v-model="row[col.field]" tabindex="3" />
                            </o-table-column>
                            <o-table-column #default="{row}" v-else-if="col.field === 'telephone'" :field="col.field" :label="col.label" :key="col.field">
                                <o-input class="o-input-width-auto" v-model="row[col.field]" />
                            </o-table-column>
                            <o-table-column #default="{row}" v-else-if="col.field === 'mobile'" :field="col.field" :label="col.label" :key="col.field">
                                <o-input class="o-input-width-auto" v-model="row[col.field]" />
                            </o-table-column>
                            <o-table-column #default="{row}" v-else-if="col.field === 'company_id'" :field="col.field" :label="col.label" :key="col.field">
                                <autocomplete-select class="o-input-width-auto" type="company" v-model="row[col.field]" :value="companyById(row[col.field])" />
                            </o-table-column>
                            <o-table-column #default="{row}" v-else-if="col.field === 'lead_owner'" :field="col.field" :label="col.label" :key="col.field">
                                <autocomplete-select class="o-input-width-auto" type="user" v-model="row[col.field]" :value="userById(row[col.field])" />
                            </o-table-column>
                            <o-table-column #default="{row}" v-else-if="col.field === 'state'" :field="col.field" :label="col.label" :key="col.field">
                                <autocomplete-select class="o-input-width-auto" type="state" v-model="row[col.field]" />
                            </o-table-column>
                            <o-table-column #default="{row}" v-else :field="col.field" :label="col.label" :key="col.field">
                                <o-input class="o-input-width-auto" v-model="row[col.field]" />
                            </o-table-column>
                        </template>
                        <o-table-column #default="{row}" class="action" label="Action" >
                            <button class="button is-success" @click.prevent="handleMerge(row)" title="Merge">
                                <span class="icon"><i class="fa fa-compress"></i></span>
                            </button>
                        </o-table-column>
                    </template>
                    <template #detail="{row}">
                        <tr v-for="(item, idx) in row.items" :key="'item_detail_' + idx">
                            <td v-if="table.detailed"></td>
                            <td v-if="table.checkable">
                              <o-checkbox v-model="checkedRows" :native-value="item.id" />
                            </td>
                            <td/>
                            <td v-for="col in tableColumns" :key="row.id + '_' + item.id + '_' + col.field">
                                <template v-if="col.field === 'first_name' || col.field === 'last_name'" >
                                    <span class="cell input">{{ item[col.field] }}</span>
                                </template>
                                <template v-else-if="col.field === 'company_id'">
                                    <o-radio v-if="!!item['company_name']" class="input cell" :native-value="item[col.field]" v-model="row[col.field]">{{ item['company_name'] }}</o-radio>
                                    <span v-else class="cell input">-</span>
                                </template>
                                <template v-else-if="col.field === 'lead_owner'" >
                                    <o-radio v-if="!!item['lead_owner_name']" class="input cell" :native-value="item[col.field]" v-model="row[col.field]">{{ item['lead_owner_name'] }}</o-radio>
                                    <span v-else class="cell input">-</span>
                                </template>
                                <template v-else >
                                    <o-radio v-if="!!item[col.field]" class="input cell" :native-value="item[col.field]" v-model="row[col.field]">{{ item[col.field] }}</o-radio>
                                    <span v-else class="cell input">-</span>
                                </template>
                            </td>
                            <td class="action">
                                <span>
                                    <button @click.prevent="handleUngroup(row, item, idx)" class="button is-warning" title="Ungroup">
                                        <span class="icon"><i class="fa fa-expand"></i></span>
                                    </button>
                                </span>
                            </td>
                        </tr>
                    </template>
                </o-table>
            </div>
        </div>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isMergedItemsModalActive" has-modal-card width="100%">
            <merged-items-modal :data="mergedItems" :table-columns="tableColumns" />
        </o-modal>
     </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Table from '../../mixins/Table'
    import MergedItemsModal from './MergedItemsModal.vue'
    import {fetchCompanyById} from "../../store/modules/companies/actions";

    export default {
        components: { MergedItemsModal },
        mixins: [Table],
        data () {
            return {
                checkedRows: [],
                defaultOpenedDetails: [],
                filters: { name: null },
                isMergedItemsModalActive: false,
                isTableVisible: true,
                mergedItems: [],
                showDetailIcon: true,
                table: {
                    checkable: true,
                    detailed: true,
                    defaultSort: ['id', 'desc'],
                    perPage: 10,
                    perPageOptions: [5, 10, 15, 25, 50],
                },
                tableName: 'merge-contacts',
                useTransition: false,
            }
        },


        computed: {
          ...mapGetters([
            'companyById',
            'userById',
          ]),

          transitionName() {
            if (this.useTransition) {
              return 'fade'
            }
          },
        },

        methods: {
            ...mapActions([
                'fetchDuplicatedContacts',
                'mergeDuplicatedContacts',
                "fetchCompanyById"
            ]),

            clearSelectedRows() {
                this.checkedRows = []
            },

            fetchData(params) {
                return this.fetchDuplicatedContacts(params).then(res => {
                        this.items = res.data.data
                        return res
                    })
            },

            handleMerge(item) {
                const full_name = (item.first_name + ' ' + item.last_name).trim()
                return this.confirmMessage(
                    'Confirm action',
                    'Confirm merge ' + full_name + ' contact?',
                    'Yes'
                ).then(() => this.mergeContacts([item]), r => Promise.reject(r))
            },

            handleMergeSelected(items) {
                return this.confirmMessage(
                    'Confirm action',
                    'Confirm merge (' + items.length + ') contacts?',
                    'Yes'
                ).then(() => this.mergeContacts(items), r => Promise.reject(r))
            },

            handleRefresh() {
                this.clearSelectedRows()
                this.currentPage = 1
                this.fetchPaginatedData()
            },

            handleUngroup(item, itemToUngroup, idx) {
                return this.confirmMessage(
                    'Confirm action',
                    'Confirm ungroup contact?',
                    'Yes'
                ).then(() => {
                    let itemToUngroupIdx = -1
                    item.items.find((ui, ui_idx) => { if(ui.id === itemToUngroup.id) itemToUngroupIdx = ui_idx})
                    itemToUngroupIdx !== -1 && item.items.splice(itemToUngroupIdx, 1)
                    const mainItem = item.items.length > 0 ? item.items[0] : null
                    if(item.id === itemToUngroup.id && mainItem !== null) {
                        for (let j = 0; j < this.tableColumns.length; j++) {
                            const { field: col } = this.tableColumns[j]
                            item[col] = mainItem[col];
                        }
                        item.id = mainItem.id;
                    }
                }, r => Promise.reject(r))
            },

            mergeContacts(items) {
                this.mergeDuplicatedContacts(items).then(() => {
                    this.handleRefresh()
                    this.successMessage('Items were merged successfull')
                    this.openMergedItemsModal(items)
                })
                    .catch(() => this.errorMessage('Error while merging items, try fill all required fields[Name, Company, Email]'))
            },

            openMergedItemsModal(items) {
                if(items.length) {
                    this.mergedItems = items
                    this.isMergedItemsModalActive = true
                }        
            },

        },
        mounted() {
            this.fetchPaginatedData()

          // setInterval(() => {
          //   this.paginatedData.map(item => {
          //     this.fetchCompanyById(item.company_id)
          //   })
          // }, 1000)
        },
        props: [],
        watch: {
            data: {
                deep: true,
                handler() {
                    this.fetchPaginatedData()
                }
            },
        },
    }
</script>

<style lang="sass" scoped>
div.control
  width: 150px

.merge-contacts-ctn
  overflow-x: auto
  .toolbar-box
    background: #f5f8fa
    margin: -12px -12px 0 -12px
    padding: 10px 6px 6px 6px
  .merge-contacts-table
    .table-wrapper
      min-height: 0
    td.action
      span
        display: flex
        justify-content: center
    .input.cell
      background: inherit
      border: none
      box-shadow: none
      .control-label
        white-space: nowrap
    tbody tr td.action, thead tr th:last-child
      position: sticky
      right: 0
      z-index: 2
      background-color: #f5f8fa
    thead tr th:last-child
      background-color: #fff
    ul
      list-style: none
</style>
